import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import Avatar from '@gik/ui/Avatar';
import Link from '@/components/Link';
import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import { useUserStore } from '@gik/core/store/UserStore';
import HTMLParser from '@gik/ui/HTMLParser';

export interface IPageRowItemProps {
  page: InkindPageAPIModel;
  className: string;
}

export default function PageRowItem({ page, className }: IPageRowItemProps): React.ReactElement {
  const bem = bemBlock('page-row-item');

  const userStore = useUserStore();
  const canEdit = canUserEditPage(page, userStore.id);

  return (
    <li className={bem(null, [{ organizer: canEdit }], className)}>
      <Link href={`/inkinds/${page.routeId}/${page.slug}`}>
        <a className={bem('container')}>
          <Avatar className={bem('avatar')} imageUrl={`${page.thumb_small}`} circle={false} rounded />
          <span className={bem('title')}>
            <HTMLParser rawHtml={page.title} />
          </span>
        </a>
      </Link>
    </li>
  );
}
